import React, { useEffect, useRef, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import 'quill-mention';
import { Mention, MentionBlot } from 'quill-mention';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { configConsumerProps } from 'antd/es/config-provider';

// Register Quill modules
Quill.register({ 'blots/mention': MentionBlot, 'modules/mention': Mention });


const MessageInput = ({ onSend, users, selectedUser, selectedGroup, typingMethod, currentUser, selectedChatId, typingPerson, setTypingPerson }) => {
  const editorRef = useRef(null); // Ref for the editor container
  const quillRef = useRef(null); // Ref to store the Quill instance
  const [message, setMessage] = useState(''); // State for message
  const [userName, setUserName] = useState(selectedUser?.Name);
  const [groupName, setGroupName] = useState(selectedGroup?.name);
  const editorInitialized = useRef(false); // Ref to track if Quill is initialized
  const [typingTimeout, setTypingTimeout] = useState(null); // Timeout to debounce typing notifications


  quillRef?.current?.root.setAttribute('data-placeholder', userName
    ? `Message ${userName}`
    : groupName
      ? `Message ${groupName}`
      : 'Please select user or group'
  );


  useEffect(() => {

    if (editorRef.current && !editorInitialized.current && users.length > 0) {
      // Initialize Quill editor

      quillRef.current = new Quill(editorRef.current, {
        theme: 'snow',

        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image', 'video'],
            ['blockquote', 'code-block'],
            [{ size: ['small', false, 'large', 'huge'] }],
            ['clean'],
          ],
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ['@'],
            source: function (searchTerm, renderList, mentionChar) {

              const atValues = users.map(user => ({
                id: user._id,
                value: user.Name
              }));
              const hashValues = [];
              let values = mentionChar === "@" ? atValues : hashValues;

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = values.filter((item) =>
                  item.value.toLowerCase().includes(searchTerm.toLowerCase())
                );
                renderList(matches, searchTerm);
              }
            },

          },
        },
      });

      editorInitialized.current = true;
      // Add an event listener to update the message state on text change
      quillRef.current.on('text-change', () => {
        const htmlContent = quillRef.current.root.innerHTML;
        setMessage(htmlContent);
        if (typingTimeout) {
          clearTimeout(typingTimeout);
        }
        setTypingTimeout(
          setTimeout(() => {
            //setTypingPerson(null);
            //typingMethod(null); 
          }, 3000)
        );

        // Notify typing immediately
        if (currentUser?.name) {
          typingMethod(currentUser.name);
        }
      });
    }
  }, [users, currentUser, typingTimeout, selectedChatId]);

  useEffect(() => {
  }, [typingPerson]);

  useEffect(() => {
    if (selectedGroup) {
      setGroupName(selectedGroup?.name);
      setUserName(null);
    }
    if (selectedUser) {
      setUserName(selectedUser?.Name);
      setGroupName(null);
    }
  }, [selectedUser, selectedGroup]);

  useEffect(() => {
    if (selectedGroup) {
      setMessage(`Message ${selectedGroup?.name}`);
    } else if (selectedUser) {
      setMessage(`Message ${selectedUser?.Name}`);
    }
  }, [selectedUser, selectedGroup]);

  const handleSend = () => {
    // Trim whitespace and check if the message only contains <br> tags or empty <p> tags
    const isMessageEmpty = message
      .replace(/<br\s*\/?>/g, '') // Remove all <br> tags
      .replace(/<p>\s*<\/p>/g, '') // Remove empty <p> tags
      .trim() === ''; // Check if the remaining content is empty

    // If the message is empty, prevent sending
    if (isMessageEmpty) {
      return;
    }

    if (selectedUser || selectedGroup) {

      onSend(message.trim());
      setMessage('');

      // Clear Quill editor content
      if (quillRef.current) {
        quillRef.current.root.innerHTML = '';
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div
      style={{
        borderTop: '1px solid #f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '10px'
      }}
    >
      {/* Editor container */}
      <div
        id="editor"
        ref={editorRef}
        style={{
          height: '100px', padding: '10px',

        }}
        onKeyDown={handleKeyDown}
      ></div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#f0f0f0',
          alignItems: 'center',
        }}
      >
        {typingPerson && typingPerson.trim() !== '' && typingPerson !== currentUser?.name && (
          <p style={{ display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' }}>
            {typingPerson} 
          </p>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }}>
          <Button
            type="primary"
            onClick={handleSend}
            disabled={!message.trim() || (!selectedUser && !selectedGroup)}
            icon={<ArrowRightOutlined />}
            style={{
              borderRadius: '50px',
              padding: '10px 20px',
              marginTop: '5px',
              marginBottom: '5px',
              marginRight: '8px',
            }}
          />
        </div>
      </div>

    </div>
  );
};

export default MessageInput;